module.exports = __webpack_public_path__ + "img/6_34.6fd10d2f.png";